var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109837:199119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54594 9.98289L2.989 12.062L0.953406 12.1051C0.345063 10.9767 0 9.68576 0 8.31389C0 6.9873 0.322625 5.7363 0.8945 4.63477H0.894938L2.70719 4.96702L3.50106 6.76839C3.33491 7.2528 3.24434 7.7728 3.24434 8.31389C3.24441 8.90114 3.35078 9.4638 3.54594 9.98289Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8601 6.81982C15.952 7.30376 15.9999 7.80354 15.9999 8.31432C15.9999 8.88707 15.9397 9.44576 15.825 9.98467C15.4355 11.8185 14.4179 13.4198 13.0083 14.553L13.0078 14.5526L10.7252 14.4361L10.4022 12.4194C11.3375 11.8708 12.0685 11.0124 12.4536 9.98467H8.17578V6.81982H12.516H15.8601Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0076 14.5521L13.0081 14.5526C11.6371 15.6545 9.89553 16.3139 7.99972 16.3139C4.95312 16.3139 2.30434 14.611 0.953125 12.1051L3.54566 9.98291C4.22125 11.786 5.96059 13.0695 7.99972 13.0695C8.87619 13.0695 9.69731 12.8326 10.4019 12.4189L13.0076 14.5521Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1064 2.15571L10.5147 4.27746C9.78553 3.82165 8.92353 3.55834 8.00003 3.55834C5.91475 3.55834 4.14287 4.90075 3.50112 6.76847L0.894969 4.63484H0.894531C2.22597 2.06781 4.90816 0.313965 8.00003 0.313965C9.94112 0.313965 11.7209 1.0054 13.1064 2.15571Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109837:199119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.313965)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.00bd07bf3e4abeb7b72b1671fac433b0.svg";
export { ForwardRef as ReactComponent };